<template>
  <div class="memberCenter_wrap ChangeInform">
    <div class="nav_pos mb_nav_pos">
      <el-breadcrumb separator-class="el-icon-arrow-right">
        <el-breadcrumb-item>
          <router-link to="/MemberCenter">首页</router-link>
        </el-breadcrumb-item>
        <el-breadcrumb-item>{{ pageType == 0 ? '企业信息变更申请' : '复评申请' }} </el-breadcrumb-item>
      </el-breadcrumb>
      <div v-if="auditStatus == 1" style="margin-right: 96px" class="back_btn" @click="goToAuditRecord(1)">查看审核进度</div>
      <div class="back_btn" @click="back">
        返回
        <img src="@/assets/img/icon_return.png" alt />
      </div>
    </div>
    <div class="content_wrap">
      <div class="change_inform">
        <div class="title">
          基本信息
          <span v-if="auditStatus == 0" class="span0">
            <img src="@/assets/img/icon_tips0.png" />企业信息{{ pageType == 0 ? '变更' : '复评' }}需经广电计量审核通过后，方可生效
          </span>
          <span v-if="auditStatus == 1" class="span1"> <img src="@/assets/img/icon_tips1.png" />审核中 </span>
          <span v-if="auditStatus == 2" class="span2"> <img src="@/assets/img/icon_tips2.png" />审核不通过：{{ auditRemark }} </span>
        </div>
        <el-form :model="ruleForm" :rules="rules" ref="ruleForm1" class="form_table1" :inline-message="true">
          <el-form-item class="allLine" label="供应商名称" prop="SupplierName">
            <el-input v-model="ruleForm.SupplierName" placeholder="请填写您公司的真实名称"></el-input>
            <span style="color: orange; margin-left: 10px">
              <img style="margin-left: 5px" src="@/assets/img/icon_tips0.png" />公司全称与营业执照保持一致
            </span>
          </el-form-item>
          <el-form-item label="统一社会信用代码" prop="SocialCreditCode" class="allLine">
            <el-input v-model="ruleForm.SocialCreditCode" placeholder="请输入统一社会信用代码"></el-input>
            <span style="color: orange; margin-left: 10px">
              <img src="@/assets/img/icon_tips0.png" />统一社会领用代码与营业执照/事业单位法人证书的统一设备信用代码一致
            </span>
          </el-form-item>
          <el-form-item label="公司类型" prop="CompanyType" ref="CompanyType">
            <el-select v-model="ruleForm.CompanyType" placeholder="请选择" class="width_full" @change="CompanyTypeFn">
              <el-option
                v-for="item in companyTypeList"
                :key="item.value"
                :label="item.text"
                :value="item.value"
                :checked="item.selected"
              ></el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="纳税人类型" prop="TaxPayerSize">
            <el-select v-model="ruleForm.TaxPayerSize" class="width_full" placeholder="请选择">
              <el-option
                v-for="item in taxPayerSizeList"
                :key="item.value"
                :label="item.text"
                :value="item.value"
                :checked="item.selected"
              ></el-option>
            </el-select>
          </el-form-item>
          <el-form-item label=" 纳税人信用等级" prop="TaxPayerSize">
            <el-select v-model="ruleForm.TaxPayerLevel" class="width_full" placeholder="请选择">
              <el-option
                v-for="item in taxPayerLevelList"
                :key="item.value"
                :label="item.text"
                :value="item.value"
                :checked="item.selected"
              ></el-option>
            </el-select>
          </el-form-item>

          <el-form-item label="供应商类型" prop="SupplierType">
            <div>
              <div><el-button icon="el-icon-search" @click.stop="openSupplierTypePage">选择供应商类型</el-button></div>
              <div v-for="(item, index) in ruleForm.SupplierTypeName" :key="index">{{ item }}</div>
            </div>
          </el-form-item>
          <el-form-item label="核心产品/服务" prop="MajorProject" class="allLine">
            <el-input v-model="ruleForm.MajorProject" type="textarea" rows="1" placeholder="请填写核心产品/服务"></el-input>
          </el-form-item>
          <el-form-item label="法定代表人" prop="LegalRepresentative">
            <el-input v-model="ruleForm.LegalRepresentative" placeholder="请填写法定代表人姓名"></el-input>
          </el-form-item>
          <el-form-item label="成立日期" prop="SetupDate">
            <el-date-picker
              class="filedate filedate1"
              value-format="yyyy-MM-dd"
              v-model="ruleForm.SetupDate"
              type="date"
              placeholder="请填写成立日期"
            ></el-date-picker>
          </el-form-item>
          <el-form-item label="注册资金（万元）" prop="RegisteredCapital">
            <el-input-number
              :controls="false"
              class="input_number"
              placeholder="请填写注册资金"
              :min="0"
              v-model="ruleForm.RegisteredCapital"
            ></el-input-number>
          </el-form-item>
          <el-form-item label="实缴资金（万元）" prop="PaidInCapital">
            <el-input-number
              :controls="false"
              placeholder="实缴资金金额来自出资证明书"
              class="input_number"
              :min="0"
              v-model="ruleForm.PaidInCapital"
            ></el-input-number>
          </el-form-item>
          <el-form-item label="注册地址" prop="RegisteredAddress" class="allLine">
            <el-cascader filterable clearable v-model="ruleForm.RegisteredAddressArr" :options="administrativeAreaList"></el-cascader>
            <el-input placeholder="请输入注册地址" v-model="ruleForm.RegisteredAddress"></el-input>
          </el-form-item>
          <el-form-item label="办公地址" prop="OfficeAddress" class="allLine">
            <el-cascader filterable clearable v-model="ruleForm.OfficeAddressArr" :options="administrativeAreaList"></el-cascader>
            <el-input placeholder="请输入办公地址" v-model="ruleForm.OfficeAddress"></el-input>
          </el-form-item>
          <el-form-item label="营业期限" prop="BusinessTermDate" class="allLine" v-if="ruleForm.IsLongBusinessDate">
            <div class="datepicker_wrap">
              <el-date-picker
                class="filedate filedate1"
                value-format="yyyy-MM-dd"
                v-model="ruleForm.BusinessTermDate[0]"
                type="date"
                placeholder="开始日期"
              ></el-date-picker>
            </div>
            <el-checkbox v-model="ruleForm.IsLongBusinessDate" class="term" @change="longterm">长期</el-checkbox>
          </el-form-item>
          <el-form-item label="营业期限" prop="BusinessTermDate" class="allLine" v-else>
            <el-date-picker
              v-model="ruleForm.BusinessTermDate"
              type="daterange"
              start-placeholder="开始日期"
              end-placeholder="结束日期"
              unlink-panels
            ></el-date-picker>
            <el-checkbox v-model="ruleForm.IsLongBusinessDate" class="term" @change="longterm">长期</el-checkbox>
          </el-form-item>
          <el-form-item label="关联公司" prop="SupplierRelatedCompany">
            <el-select v-model="ruleForm.SupplierRelatedCompany" class="width_full" :multiple="true">
              <el-option :label="item.text" :value="item.value" v-for="(item, index) in supplierRelatedCompanyList" :key="index"></el-option>
            </el-select>
          </el-form-item>
          <el-form-item></el-form-item>
          <el-form-item label="经营范围" prop="BusinessScope" class="allLine">
            <el-input v-model="ruleForm.BusinessScope" type="textarea" rows="1" placeholder="请填写经营范围"></el-input>
          </el-form-item>
          <el-form-item label="资产总计（万元）" prop="TotalAssets">
            <el-input-number
              :controls="false"
              placeholder="请填写资产总计"
              class="input_number"
              :min="0"
              v-model="ruleForm.TotalAssets"
            ></el-input-number>
          </el-form-item>
          <el-form-item label="上年营业收入" prop="LastYearTotalSales">
            <el-input-number
              :controls="false"
              placeholder="请填写上年营业收入"
              class="input_number"
              :min="0"
              v-model="ruleForm.LastYearTotalSales"
            ></el-input-number>
          </el-form-item>
          <el-form-item label="售后服务承诺和措施" prop="AfterSalesService" class="allLine">
            <el-input v-model="ruleForm.AfterSalesService" type="textarea" rows="1" placeholder="请填写售后服务承诺和措施"> </el-input>
          </el-form-item>
          <el-form-item label="公司简介" prop="CompanyProfile" class="allLine">
            <el-input type="textarea" rows="1" v-model="ruleForm.CompanyProfile" placeholder="请填写公司简介"></el-input>
          </el-form-item>
          <el-form-item label="公司网址" prop="Website" class="allLine">
            <el-input type="textarea" rows="1" v-model="ruleForm.Website" placeholder="请填写公司网址"></el-input>
          </el-form-item>
        </el-form>
      </div>
      <FileList :FileList.sync="fileList1" v-if="fileList1.length" :FileType="2" ref="MsgForm1" :supplierId="supplierId" />
      <div class="change_inform">
        <div class="title">公司物业及人员情况</div>
        <el-form :model="ruleForm" :rules="rules" ref="ruleForm2" class="form_table1">
          <el-form-item label="自有物业所有权面积(平方)" prop="OwnArea">
            <el-input v-model="ruleForm.OwnArea" placeholder="请填写自有物业所有权面积"></el-input>
          </el-form-item>
          <el-form-item label="租赁物业所有权面积(平方)" prop="LeasingArea">
            <el-input v-model="ruleForm.LeasingArea" placeholder="请填写租赁物业所有权面积"></el-input>
          </el-form-item>
          <el-form-item label="公司总人数" prop="TotalCount">
            <el-input-number
              :controls="false"
              placeholder="请填写公司总人数"
              class="input_number"
              :min="0"
              v-model="ruleForm.TotalCount"
            ></el-input-number>
          </el-form-item>
          <el-form-item label="社保人数" prop="SocialInsuranceCount">
            <el-input-number
              :controls="false"
              placeholder="请填写社保人数"
              class="input_number"
              :min="0"
              v-model="ruleForm.SocialInsuranceCount"
            ></el-input-number>
          </el-form-item>
          <el-form-item label="相关附件" class="allLine">
            <FileList
              :FileList.sync="fileList1"
              v-if="fileList1.length"
              :SocialInsuranceCount="ruleForm.SocialInsuranceCount"
              :FileType="3"
              ref="MsgForm3"
            />
          </el-form-item>
        </el-form>
      </div>
      <div class="change_inform">
        <div class="title">联系人信息</div>
        <el-form :model="ruleForm" :rules="rules" ref="ruleForm3" class="form_table1">
          <el-form-item label="引入来源" prop="IntroductionSource">
            <el-select v-model="ruleForm.IntroductionSource" class="width_full" placeholder="请选择">
              <el-option v-for="item in introductionSourceList" :key="item.value" :label="item.text" :value="item.value"></el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="推荐人" label-width="180px" prop="Referrer" v-if="ruleForm.IntroductionSource == '0'">
            <div style="width: 100%">
              <div style="padding-bottom: 10px">
                <el-input placeholder="请输入推荐人手机" class="width_full1" v-model="ReferrerName"></el-input>
                <el-button style="margin-left: 10px" type="primary" @click="querySearchAsync()">查找</el-button>
              </div>
              已选推荐人:
              <div class="name_wrap name_wrap2" v-if="ruleForm.Referrer != 0">
                <span>{{ ruleForm.ReferrerName }}|{{ ruleForm.ReferrerMobile }}</span>
                <i style="cursor: pointer" @click="deleteReferrerName()" class="el-icon-delete"></i>
              </div>
            </div>
          </el-form-item>
          <el-form-item label="引入项目" prop="ProjectName" v-else-if="ruleForm.IntroductionSource == '1'">
            <div style="width: 100%">
              <div style="padding-bottom: 10px">
                <el-input placeholder="请输入完整的项目名称" class="width_full1" v-model="ProjectName"></el-input>
                <el-button style="margin-left: 10px" type="primary" @click="querySearchAsync1()">查找</el-button>
              </div>
              已选项目:
              <div class="name_wrap name_wrap2" v-if="ruleForm.SchemeId != 0">
                <span>{{ ruleForm.ProjectName }}</span>
                <i style="cursor: pointer" @click="deleteProjectName()" class="el-icon-delete"></i>
              </div>
            </div>
          </el-form-item>
          <el-form-item label="联系人信息" class="allLine">
            <div class="MsgForm form_wrap" style="width: -webkit-fill-available">
              <div class="form_wrap" style="height: 30px">
                <div class="btn_wrap" style="width: unset; margin: unset">
                  <img src="@/assets/img/btn_add.png" alt @click="addContact" />
                  <img src="@/assets/img/btn_delete.png" alt @click="removeContact" />
                </div>
              </div>
              <table class="enclosure">
                <tbody>
                  <tr>
                    <th width="40px">
                      <el-checkbox v-model="allContactCheck"></el-checkbox>
                    </th>
                    <th><span class="icon_must">*</span>主要联系人</th>
                    <th><span class="icon_must">*</span>姓名</th>
                    <th><span class="icon_must">*</span>职位</th>
                    <th><span class="icon_must">*</span>手机号码</th>
                    <th><span class="icon_must">*</span>电子邮箱</th>
                  </tr>
                  <tr v-for="(item, index) in spplierContactList" :key="index">
                    <td><el-checkbox v-model="item.check"></el-checkbox></td>
                    <td>
                      <el-select v-model="item.IsPrimary" @change="setIsPrimary(index)">
                        <el-option label="主要联系人" :value="true"></el-option>
                        <el-option label="非主要联系人" :value="false"></el-option>
                      </el-select>
                    </td>
                    <td><el-input style="width: 150px" v-model="item.ContactName"></el-input></td>
                    <td><el-input style="width: 150px" v-model="item.Duty"></el-input></td>
                    <td><el-input style="width: 150px" v-model="item.Mobile"></el-input></td>
                    <td><el-input style="width: 150px" v-model="item.Email"></el-input></td>
                  </tr>
                </tbody>
              </table>
            </div>
          </el-form-item>
        </el-form>
      </div>

      <div class="change_inform">
        <div class="title">银行收款信息</div>
        <el-form :model="ruleForm" :rules="rules" ref="ruleForm4" class="form_table1">
          <el-form-item label="开户名称" prop="Bank">
            <el-input v-model="ruleForm.Bank" placeholder="请填写开户银行名称"></el-input>
          </el-form-item>

          <el-form-item label="开户银行账户" prop="BankAccount">
            <el-input v-model="ruleForm.BankAccount" placeholder="请填写开户银行账户"></el-input>
          </el-form-item>
          <el-form-item label="联行号" prop="BankApprovalNumber">
            <el-input v-model="ruleForm.BankApprovalNumber" maxlength="12" placeholder="请填写联行号"></el-input>
          </el-form-item>
          <el-form-item label="开户银行名称" prop="BankAccountName">
            <el-input v-model="ruleForm.BankAccountName" placeholder="请填写开户名称"></el-input>
          </el-form-item>
          <el-form-item label="相关附件" class="allLine">
            <FileList :FileList.sync="fileList1" v-if="fileList1.length" :FileType="4" ref="MsgForm4" />
          </el-form-item>
        </el-form>
      </div>
      <div class="change_inform" v-if="showMainBusiness">
        <div class="title">主营业务和客户分布情况</div>
        <div class="radio-group-container">
          <p class="question">贵司是否愿意提供更多信息以便在未来获取与广电计量更广泛、更深入的合作机会？</p>

          <el-radio-group v-model="selectMainBusiness">
            <el-radio :label="true" class="custom-radio">
              <span class="radio-label">愿意</span>
              <span class="hint-text">（需填写主营业务和客户分布情况信息）</span>
            </el-radio>

            <el-radio :label="false" class="custom-radio">
              <span class="radio-label">不愿意</span>
              <span class="hint-text">（无需填写主营业务和客户分布情况信息）</span>
            </el-radio>
          </el-radio-group>
        </div>
        <el-form :model="ruleForm" :rules="rules" ref="ruleForm5" class="form_table1" v-if="selectMainBusiness == true">
          <el-form-item label="主营业务情况（近三年）" class="allLine">
            <div class="MsgForm form_wrap" style="width: -webkit-fill-available">
              <div class="form_wrap" style="height: 30px">
                <div class="btn_wrap" style="width: unset; margin: unset">
                  <img src="@/assets/img/btn_add.png" alt @click="addMainBusiness" />
                  <img src="@/assets/img/btn_delete.png" alt @click="removeMainBusiness" />
                </div>
              </div>
              <table class="enclosure">
                <tbody>
                  <tr>
                    <th width="40px">
                      <el-checkbox v-model="allMainBusinesseCheck"></el-checkbox>
                    </th>
                    <th><span class="icon_must">*</span>年份</th>
                    <th><span class="icon_must">*</span>主要业务</th>
                    <th><span class="icon_must">*</span>具体产品/服务</th>
                    <th><span class="icon_must">*</span>品牌</th>
                    <th><span class="icon_must">*</span>年营业额（万元）</th>
                    <th><span class="icon_must">*</span>主要客户</th>
                    <th><span class="icon_must">*</span>主要竞争对手</th>
                    <th><span class="icon_must">*</span>品牌竞争对手</th>
                  </tr>
                  <tr v-for="(item, index) in supplierMainBusinesseList" :key="index">
                    <td><el-checkbox v-model="item.check"></el-checkbox></td>
                    <td>
                      <el-date-picker style="width: 100%" v-model="item.Years" type="year" value-format="yyyy" placeholder="年份"></el-date-picker>
                    </td>
                    <td><el-input style="width: 100%" v-model="item.MainBusiness"></el-input></td>
                    <td><el-input style="width: 100%" v-model="item.ProductName"></el-input></td>
                    <td><el-input style="width: 100%" v-model="item.Brand"></el-input></td>
                    <td>
                      <el-input-number
                        style="width: 100%"
                        :controls="false"
                        class="input_number input_number1"
                        :min="0"
                        v-model="item.YearTotalSales"
                        placeholder="请填写年营业额（万元）"
                      >
                      </el-input-number>
                    </td>
                    <td><el-input style="width: 100%" v-model="item.MainCustome"></el-input></td>
                    <td><el-input style="width: 100%" v-model="item.BrandCompetitor"></el-input></td>
                    <td><el-input style="width: 100%" v-model="item.CompanyCompetitor"></el-input></td>
                  </tr>
                </tbody>
              </table>
            </div>
          </el-form-item>
          <el-form-item label="客户分布情况（近三年）" class="allLine">
            <div class="MsgForm form_wrap" style="width: -webkit-fill-available">
              <div class="form_wrap" style="height: 30px">
                <div class="btn_wrap" style="width: unset; margin: unset">
                  <img src="@/assets/img/btn_add.png" alt @click="addCustomDistribution" />
                  <img src="@/assets/img/btn_delete.png" alt @click="removeCustomDistribution" />
                </div>
              </div>
              <table class="enclosure">
                <tbody>
                  <tr>
                    <th width="40px">
                      <el-checkbox v-model="allCustomDistributionCheck"></el-checkbox>
                    </th>
                    <th><span class="icon_must">*</span>年份</th>
                    <th><span class="icon_must">*</span>客户所处行业</th>
                    <th><span class="icon_must">*</span>客户代表</th>
                    <th><span class="icon_must">*</span>销售额（万元）</th>
                    <th>备注</th>
                  </tr>
                  <tr v-for="(item, index) in supplierCustomDistributionList" :key="index">
                    <td><el-checkbox v-model="item.check"></el-checkbox></td>
                    <td>
                      <el-date-picker style="width: 100%" v-model="item.Years" type="year" value-format="yyyy" placeholder="年份"></el-date-picker>
                    </td>
                    <td><el-input style="width: 100%" v-model="item.IndustrialCustomers"></el-input></td>
                    <td><el-input style="width: 100%" v-model="item.Representative"></el-input></td>
                    <td>
                      <el-input-number
                        style="width: 100%"
                        :controls="false"
                        class="input_number input_number1"
                        :min="0"
                        v-model="item.TotalSales"
                        placeholder="销售额（万元）"
                      >
                      </el-input-number>
                    </td>
                    <td><el-input style="width: 100%" v-model="item.Remark"></el-input></td>
                  </tr>
                </tbody>
              </table>
            </div>
          </el-form-item>
        </el-form>
      </div>

      <div class="change_inform" v-if="showFinance">
        <div class="title">财务信息（贵司提供财报仅作为资审依据，并会对财报内容严格保密）</div>
        <div style="display: flex">
          <div class="radio-group-container">
            <el-radio-group v-model="selectFinance" @change="selectFinanceStatusChange">
              <el-radio :label="true" class="custom-radio">
                <span class="radio-label">可提供</span>
              </el-radio>

              <el-radio :label="false" class="custom-radio">
                <span class="radio-label">无法提供</span>
              </el-radio>
            </el-radio-group>
          </div>
          <div style="padding-left: 100px; padding-top: 19px" v-if="selectFinance == true">
            <p style="padding-bottom: 10px">
              <span class="span0">说明:</span>
            </p>
            <p style="padding-bottom: 10px">1、资产总计，数据来源于《资产负债表》</p>
            <p style="padding-bottom: 10px">2、营业收入，数据来源于《利润表》</p>
            <p style="padding-bottom: 10px">3、净利润，数据来源于《利润表》</p>
            <p style="padding-bottom: 10px">
              4、经营性净现金流=经营活动现金流入总额-经营活动现金流出总额，数据来源于企业现金流量表中的“经营活动产生的现金流量净额”项目
            </p>
            <p style="padding-bottom: 10px">5、资产负债率=（负债合计/资产合计）*100%</p>
          </div>
        </div>
        <div class="MsgForm form_wrap" style="width: -webkit-fill-available" v-if="selectFinance == true">
          <div class="form_wrap" style="height: 30px">
            <div class="btn_wrap" style="width: unset; margin: unset">
              <img src="@/assets/img/btn_add.png" alt @click="addFinanceStatuse" />
              <img src="@/assets/img/btn_delete.png" alt @click="removeFinanceStatuse" />
            </div>
          </div>
          <table class="enclosure">
            <tbody>
              <tr>
                <th width="40px">
                  <el-checkbox v-model="allFinanceStatuseCheck"></el-checkbox>
                </th>
                <th><span class="icon_must">*</span>年份</th>
                <th><span class="icon_must">*</span>资产总计（万元）</th>
                <th><span class="icon_must">*</span>营业收入（万元）</th>
                <th><span class="icon_must">*</span>净利润（万元）</th>
                <th><span class="icon_must">*</span>经营性净现金流（万元）</th>
                <th><span class="icon_must">*</span>资产负债率</th>
              </tr>
              <tr v-for="(item, index) in supplierFinanceStatuseList" :key="index">
                <td><el-checkbox v-model="item.check"></el-checkbox></td>
                <td>
                  <el-date-picker style="width: 100%" v-model="item.Years" type="year" placeholder="年份"></el-date-picker>
                </td>
                <td>
                  <el-input-number
                    style="width: 100%"
                    :controls="false"
                    class="input_number input_number1"
                    v-model="item.TotalAssets"
                    placeholder="资产总计（万元）"
                  >
                  </el-input-number>
                </td>
                <td>
                  <el-input-number
                    style="width: 100%"
                    :controls="false"
                    class="input_number input_number1"
                    v-model="item.OperatingIncome"
                    placeholder="营业收入（万元）"
                  >
                  </el-input-number>
                </td>
                <td>
                  <el-input-number
                    style="width: 100%"
                    :controls="false"
                    class="input_number input_number1"
                    v-model="item.NetProfit"
                    placeholder="净利润（万元）"
                  >
                  </el-input-number>
                </td>
                <td>
                  <el-input-number
                    style="width: 100%"
                    :controls="false"
                    class="input_number input_number1"
                    v-model="item.OperatingNetCash"
                    placeholder="经营性净现金流（万元）"
                  >
                  </el-input-number>
                </td>
                <td>
                  <el-input-number
                    style="width: 90%"
                    :controls="false"
                    class="input_number input_number1"
                    v-model="item.AssetLoadRate"
                    placeholder="资产负载率"
                  >
                  </el-input-number
                  >%
                </td>
              </tr>
            </tbody>
          </table>
        </div>
        <el-form :model="ruleForm" :rules="rules" ref="ruleForm6" class="form_table1" v-if="selectFinance == false">
          <el-form-item label="无法提供财务数据的原因" prop="FinanceRemark" class="allLine">
            <el-input v-model="ruleForm.FinanceRemark" type="textarea" rows="1" placeholder="请填写无法提供财务数据的原因"> </el-input>
          </el-form-item>
        </el-form>
      </div>

      <Qualification
        :FileList.sync="supplierQualificationList"
        v-if="supplierQualificationList.length && ruleForm.TaxPayerSize != 3 && ruleForm.TaxPayerSize != 4"
        ref="QualificationForm"
      />

      <SupplierType
        :tableData="supplierTypeTree"
        :tableData1="supplierTypeList"
        :dialogvisible.sync="dialogvisible"
        :selectSupplierType.sync="selectSupplierType"
      ></SupplierType>
      <div class="btn_wrap changeInform_btn_wrap">
        <span class="btn_1" v-if="auditStatus == 0 || auditStatus == 2" @click="reflash">重 置</span>
        <span class="btn_1" v-if="auditStatus == 0 || auditStatus == 2" @click="submit(true)">提交申请</span>
        <span class="btn_1" style="margin-left: 8px" v-if="auditStatus == 0 || auditStatus == 2" @click="submit(false)">保存草稿</span>
        <span class="btn_1" v-if="auditStatus == 1" @click="cancel">撤销申请</span>
      </div>
    </div>
  </div>
</template>

<script>
import MsgForm from '@/components/common/MsgForm'
import ProductInfo from '@/components/common/ProductInfo'
import IntellectualPropertyFrom from '@/components/common/IntellectualPropertyFrom'
import SupplierType from '@/components/common/SupplierType'
import FileList from '@/components/common/FileList'
import Qualification from '@/components/common/Qualification'
import { validateEmail, validatemobile1, validateSocialCreditCode, validContact } from '@/assets/js/util'
export default {
  inject: ['reload'],
  components: {
    MsgForm,
    ProductInfo,
    IntellectualPropertyFrom,
    SupplierType,
    FileList,
    Qualification
  },
  data() {
    var validRegisteredAddress = (rule, value, callback) => {
      if (this.ruleForm.RegisteredAddressArr[0] == null || this.ruleForm.RegisteredAddress == '') {
        callback(new Error('请填写注册地址'))
      } else {
        // 其他统一的验证逻辑
        callback()
      }
    }
    var validOfficeAddress = (rule, value, callback) => {
      if (this.ruleForm.OfficeAddressArr[0] == null || this.ruleForm.OfficeAddress == '') {
        callback(new Error('请填写办公地址'))
      } else {
        // 其他统一的验证逻辑
        callback()
      }
    }
    var validProduct = (rule, value, callback) => {
      if (this.ruleForm.SupplierProductList.length == 0 && this.ruleForm.OtherSupplierProductList === '') {
        callback(new Error('请填写核心产品'))
      } else {
        // 其他统一的验证逻辑
        callback()
      }
    }
    return {
      ReferrerName: '',
      ProjectName: '',
      selectSupplierType: [],
      dialogvisible: false,
      type: 0,
      auditStatus: 0, //审核状态：0是未申请，1是申请中,2是申请不通过
      FileList: [],
      ruleForm: {},
      isSupplierOtherType: false,
      socialCreditCode: '',
      certificateNo: '',
      pageType: 0,
      treeprops: {
        label: 'name',
        Child: 'children'
      },
      allContactCheck: '',
      allMainBusinesseCheck: '',
      allFinanceStatuseCheck: '',
      allCustomDistributionCheck: '',
      rules: {
        SupplierType: [{ required: true, message: '请选择供应商类型', trigger: 'blur' }],
        SupplierName: [{ required: true, message: '请输入供应商名称', trigger: 'blur' }],
        SocialCreditCode: [{ required: true, message: '', trigger: 'blur' }],
        LegalRepresentative: [{ required: true, message: '请输入法定代表人', trigger: 'blur' }],
        RegisteredCapital: [{ required: true, message: '请输入注册资本', trigger: 'blur' }],
        StaffSize: [{ required: true, message: '请选择人员规模', trigger: 'change' }],
        BusinessTermDate: [{ required: true, message: '请输入营业期限', trigger: 'change' }],
        BusinessScope: [{ required: true, message: '请输入经营范围', trigger: 'blur' }],
        RegisteredAddress: [{ required: true, message: '请输入注册地址', trigger: 'blur', validator: validRegisteredAddress }],
        SupplierNature: [{ required: true, message: '请选择供应商性质', trigger: 'blur' }],
        SupplierProductList: [{ required: true, validator: validProduct, message: '请选择供核心产品', trigger: 'blur' }],
        OfficeAddress: [{ required: true, message: '请输入办公地址', trigger: 'blur', validator: validOfficeAddress }],
        // CompanyProfile: [{ required: true, message: '请输入公司简介', trigger: 'blur' }],
        Contact: [{ required: true, validator: validContact, trigger: 'blur' }],
        CertificateType: [{ required: true, message: '请选择证件类型', trigger: 'change' }],
        CertificateNo: [{ required: true, message: '', trigger: 'blur' }],
        Bank: [{ required: true, message: '请输入开户银行名称', trigger: 'blur' }],
        BankAccount: [{ required: true, message: '请输入开户银行账户', trigger: 'blur' }],
        CompanyType: [{ required: true, message: '请选择公司类型', trigger: 'change' }],
        ContactAddress: [{ required: true, message: '请输入开户银行账户', trigger: 'blur' }],
        SupplierOtherType: [{ required: true, message: '请输入其他供应商类型', trigger: 'blur' }],
        TaxPayerSize: [{ required: true, message: '请选择纳税人规模', trigger: 'blur' }],
        Sex: [{ required: true, message: '请选择性别', trigger: 'change' }],
        Email: [{ required: true, validator: validateEmail, trigger: 'blur' }],
        Mobile: [{ required: true, validator: validatemobile1, trigger: 'blur' }],
        QualityDirector: [{ required: true, message: '请填写质管负责人', trigger: 'blur' }],
        QualityMobile: [{ required: true, validator: validatemobile1, trigger: 'blur' }],
        FixedAssets: [{ required: false, message: '请输入固定资产', trigger: 'blur' }],
        LastYearTotalSales: [{ required: true, message: '请输入去年销售总额', trigger: 'blur' }],
        MajorProject: [{ required: true, message: '请填写售后服务承诺和措施', trigger: 'blur' }],
        AfterSalesService: [{ required: true, message: '请填写主要产品或服务', trigger: 'blur' }],
        SupplierRelatedCompany: [{ required: true, message: '请选择公司维度', trigger: 'blur' }],
        PaidInCapital: [{ required: true, message: '请输入实缴资本', trigger: 'blur' }],
        FixedAssets: [{ required: false, message: '请输入固定资产', trigger: 'blur' }],
        WorkerNumber: [{ required: false, message: '请输入生产工人数', trigger: 'blur' }],
        QualityManagerNumber: [{ required: false, message: '请输入质量管理人数', trigger: 'blur' }],
        TechnicianNumber: [{ required: false, message: '请输入技术人员数', trigger: 'blur' }],
        ReferrerName: [{ required: this.ReferrerNameVaildate, message: '请输入推荐人', trigger: 'blur' }],
        ProjectName: [{ required: this.ProjectNameVaildate, message: '请输入引入项目', trigger: 'blur' }],
        IntroductionSource: [{ required: true, message: '请选择引入来源', trigger: 'blur' }],
        ProductTestingMethod: [{ required: false, message: '请输入产品检测手段', trigger: 'blur' }],
        TaxPayerLevel: [{ required: true, message: '请选择纳税人信用等级', trigger: 'blur' }],
        MajorProject: [{ required: true, message: '请填写主要产品或服务', trigger: 'blur' }],
        BankAccountName: [{ required: true, message: '请填写开户银行名称', trigger: 'blur' }],
        SetupDate: [{ required: true, message: '请填写成立日期', trigger: 'blur' }],
        TotalAssets: [{ required: true, message: '请填写资产总计', trigger: 'blur' }],
        TotalCount: [{ required: true, message: '请填写公司总人数', trigger: 'blur' }],
        SocialInsuranceCount: [{ required: true, message: '请填写社保人数', trigger: 'blur' }],
        FinanceRemark: [{ required: true, message: '请填写无法提供财务数据的原因', trigger: 'blur' }]
      },
      baseDataSupplierQualificationList: [],
      supplierQualificationList: [],
      spplierContactList: [],
      supplierTypeTree: [],
      supplierNatureList: [],
      introductionSourceList: [],
      taxPayerSizeList: [],
      propertyStateList: [],
      supplierTypeList: [],
      supplierCategoryList: [],
      registeredCurrencyList: [],
      staffSizeList: [],
      companyList: [],
      fileList1: [],
      administrativeAreaList: [],
      companyTypeList: [],
      taxPayerLevelList: [],
      supplierMainBusinesseList: [],
      supplierFinanceStatuseList: [],
      supplierCustomDistributionList: [],
      supplierRelatedCompanyList: [],
      showMainBusiness: false,
      showFinance: false,
      selectMainBusiness: true,
      selectFinance: true,
      supplierId: '',
      schemeList: [],
      userList: []
    }
  },
  computed: {
    SocialCreditCode() {
      return this.ruleForm.SocialCreditCode
    },
    CertificateNo() {
      return this.ruleForm.CertificateNo
    },
    FixedAssets() {
      return this.ruleForm.FixedAssets
    },
    RegisteredCapital() {
      return this.ruleForm.RegisteredCapital
    },
    LastYearTotalSales() {
      return this.ruleForm.LastYearTotalSales
    },
    ReferrerNameVaildate() {
      return this.ruleForm.IntroductionSource == '0' ? true : false
    },
    ProjectNameVaildate() {
      return this.ruleForm.IntroductionSource == '1' ? true : false
    }
  },
  watch: {
    allContactCheck(val) {
      this.spplierContactList.forEach((element) => {
        if (element.hasOwnProperty('check')) {
          element.check = val
        }
      })
    },
    allMainBusinesseCheck(val) {
      this.supplierMainBusinesseList.forEach((element) => {
        if (element.hasOwnProperty('check')) {
          element.check = val
        }
      })
    },
    allFinanceStatuseCheck(val) {
      this.supplierFinanceStatuseList.forEach((element) => {
        if (element.hasOwnProperty('check')) {
          element.check = val
        }
      })
    },
    allCustomDistributionCheck(val) {
      this.supplierCustomDistributionList.forEach((element) => {
        if (element.hasOwnProperty('check')) {
          element.check = val
        }
      })
    },
    selectSupplierType(newVal, oldVal) {
      var isVaildate = false
      this.supplierQualificationList = []
      this.ruleForm.SupplierTypeName = []
      this.ruleForm.SupplierType = []
      newVal.forEach((item) => {
        this.ruleForm.SupplierTypeName.push(item.firstName + '-' + item.secondName + '-' + item.supplierTypeName)
        this.ruleForm.SupplierType.push(item.paramItemCode)
        var list = this.baseDataSupplierQualificationList.filter((m) => m.SupplierType.includes(item.paramItemCode))
        console.log(list)
        list.forEach((item1, index) => {
          var data = {
            QualificationTypeId: item1.QualificationTypeId,
            check: false,
            QualificationTypeName: item1.QualificationName,
            FileId: 0,
            QualificationName: '',
            IsMust: item1.IsMust,
            QualificationId: 0,
            Remark: '',
            ServiceLifeDate: ['', ''],
            QualificationStatus: ''
          }
          if (this.supplierQualificationList.filter((m) => m.QualificationTypeId == item1.QualificationTypeId).length == 0) {
            this.supplierQualificationList.push(data)
          }
        })

        // console.log(this.supplierQualificationList)
        // if (item.paramItemCode.indexOf('GC') >= 0 || item.paramItemCode.indexOf('SP') >= 0) {
        //   isVaildate = true
        // }
      })

      // if ((isVaildate = true)) {
      //   this.rules.FixedAssets[0].required = true
      //   this.rules.WorkerNumber[0].required = true
      //   this.rules.QualityManagerNumber[0].required = true
      //   this.rules.TechnicianNumber[0].required = true
      //   this.rules.ProductTestingMethod[0].required = true
      //   this.rules.SupplierProductList[0].required = true
      // } else {
      //   this.rules.FixedAssets[0].required = false
      //   this.rules.WorkerNumber[0].required = false
      //   this.rules.QualityManagerNumber[0].required = false
      //   this.rules.TechnicianNumber[0].required = false
      //   this.rules.ProductTestingMethod[0].required = false
      //   this.rules.SupplierProductList[0].required = false
      // }
    },
    SocialCreditCode(newVal, oldVal) {
      if (newVal == this.socialCreditCode) {
        delete this.rules.SocialCreditCode[0].validator
      } else {
        this.rules.SocialCreditCode[0].validator = validateSocialCreditCode
      }
    },
    CertificateNo(newVal, oldVal) {
      if (newVal == this.certificateNo) {
        delete this.rules.CertificateNo[0].validator
      } else {
        this.rules.CertificateNo[0].validator = validateSocialCreditCode
      }
    },
    ReferrerNameVaildate(newVal) {
      this.rules.ReferrerName[0].required = newVal
    }
  },
  mounted() {
    if (this.$route.query.pageType != null) {
      this.pageType = this.$route.query.pageType
      console.log(111)
    }
    console.log(this.pageType)
    this.getList()
  },
  methods: {
    goToAuditRecord(type) {
      this.$router.push({
        path: '/AuditRecord',
        query: {
          pageType: type
        }
      })
    },
    back() {
      this.$router.push('/MemberCenter')
    },
    addContact() {
      var data = {
        ContactName: '',
        Duty: '',
        Mobile: '',
        Email: '',
        IsPrimary: false,
        check: false
      }
      this.spplierContactList.push(data)
    },
    addMainBusiness() {
      var data = {
        Years: '',
        MainBusiness: '',
        ProductName: '',
        Brand: '',
        MainCustome: '',
        BrandCompetitor: '',
        CompanyCompetitor: '',
        YearTotalSales: '',
        check: false
      }
      this.supplierMainBusinesseList.push(data)
    },
    addFinanceStatuse() {
      var data = {
        Years: '',
        NetProfit: '',
        TotalAssets: '',
        AssetLoadRate: '',
        OperatingIncome: '',
        OperatingNetCash: '',
        check: false
      }
      this.supplierFinanceStatuseList.push(data)
    },
    addCustomDistribution() {
      var data = {
        Years: '',
        IndustrialCustomers: '',
        TotalSales: '',
        Representative: '',
        Remark: '',
        check: false
      }
      this.supplierCustomDistributionList.push(data)
    },
    removeContact() {
      this.spplierContactList = this.spplierContactList.filter((item) => {
        return !item.check
      })
    },
    removeMainBusiness() {
      this.supplierMainBusinesseList = this.supplierMainBusinesseList.filter((item) => {
        return !item.check
      })
    },
    removeFinanceStatuse() {
      this.supplierFinanceStatuseList = this.supplierFinanceStatuseList.filter((item) => {
        return !item.check
      })
    },
    removeCustomDistribution() {
      this.supplierCustomDistributionList = this.supplierCustomDistributionList.filter((item) => {
        return !item.check
      })
    },
    // handleChange() {
    //   //供应商
    //   if (this.ruleForm.SupplierType.includes(0)) {
    //     this.isSupplierOtherType = true;
    //   } else {
    //     this.isSupplierOtherType = false;
    //   }
    // },
    getList() {
      this.postRequest('SupplierLogin/SupplierChangeEdit', { pageType: this.pageType }).then((res) => {
        if (res.data.errcode == 0) {
          if (this.pageType == 0) {
            this.auditStatus = res.data.auditState
            this.auditRemark = res.data.auditRemark
          } else {
            this.auditStatus = res.data.reauditState
            this.auditRemark = res.data.reauditRemark
          }

          this.ruleForm = res.data.supplierData
          this.supplierId = this.ruleForm.supplierId1
          this.type = this.ruleForm.SupplierCategory
          this.socialCreditCode = this.ruleForm.SocialCreditCode
          this.certificateNo = this.ruleForm.CertificateNo
          this.baseDataSupplierQualificationList = res.data.baseDataSupplierQualificationList
          this.supplierQualificationList = res.data.supplierQualificationList
          this.spplierContactList = res.data.spplierContactList
          this.supplierTypeTree = res.data.supplierTypeTree
          this.supplierNatureList = res.data.supplierNatureList
          this.introductionSourceList = res.data.introductionSourceList
          this.taxPayerSizeList = res.data.taxPayerSizeList
          this.propertyStateList = res.data.propertyStateList
          this.supplierTypeList = res.data.supplierTypeList
          this.supplierCategoryList = res.data.supplierCategoryList
          // this.userList = res.data.userList
          // this.schemeList = res.data.schemeList
          this.companyList = res.data.companyList
          this.supplierRelatedCompanyList = res.data.supplierRelatedCompanyList
          this.fileList1 = res.data.fileList1
          // this.fileList2 = res.data.fileList2
          this.administrativeAreaList = res.data.administrativeAreaList
          this.supplierMainBusinesseList = res.data.supplierMainBusinesseList
          this.supplierFinanceStatuseList = res.data.supplierFinanceStatuseList
          this.supplierCustomDistributionList = res.data.supplierCustomDistributionList
          if (this.supplierMainBusinesseList.length == 0) {
            this.addMainBusiness()
          }
          if (this.supplierFinanceStatuseList.length == 0) {
            this.addFinanceStatuse()
          }
          if (this.supplierCustomDistributionList.length == 0) {
            this.addCustomDistribution()
          }
          this.companyTypeList = res.data.companyTypeList
          this.taxPayerLevelList = res.data.taxPayerLevelList
          this.showFinance = res.data.showFinance
          this.showMainBusiness = res.data.showMainBusiness
          if (this.showFinance == false) {
            this.selectFinance = false
          }
          if (this.showMainBusiness == false) {
            this.selectMainBusiness = false
          }
          // if (
          //   this.ruleForm.SupplierOtherType == "" ||
          //   this.ruleForm.SupplierOtherType == null
          // ) {
          //   this.isSupplierOtherType = false;
          // } else {
          //   this.isSupplierOtherType = true;
          // }
          // this.rules.BusinessTermBeginDate[0].required = !this.ruleForm.IsLongBusinessDate;
          // this.rules.BusinessTerDate[0].required = !this.ruleForm
          //   .IsLongBusinessDate;
          // this.FileList = this.ruleForm.FileList1
          // if (this.type === 0) {
          //   this.ruleForm.SupplierTypeList = this.ruleForm.SupplierTypeList.filter(
          //     item => {
          //       return item.parentCode == 2 || item.parentCode == 0;
          //     }
          //   );
          // } else if (this.type === 1) {
          //   this.ruleForm.SupplierTypeList = this.ruleForm.SupplierTypeList.filter(
          //     item => {
          //       return item.parentCode == 2 || item.parentCode == 1;
          //     }
          //   );
          // }
          this.initData()
        } else {
          this.$message.error(res.data.errmsg)
        }
      })
    },
    initData() {
      if (this.ruleForm.SupplierNature == 0) {
        this.ruleForm.SupplierNature = ''
      }
      if (this.supplierQualificationList.length == 0 && this.ruleForm.SupplierType.length > 0) {
        this.ruleForm.SupplierType.forEach((item) => {
          var list = this.baseDataSupplierQualificationList.filter((m) => m.SupplierType.includes(item))
          list.forEach((item1, index) => {
            var data = {
              QualificationTypeId: item1.QualificationTypeId,
              check: false,
              QualificationTypeName: item1.QualificationName,
              FileId: 0,
              QualificationName: '',
              IsMust: item1.IsMust,
              QualificationId: 0,
              Remark: '',
              ServiceLifeDate: ['', ''],
              QualificationStatus: ''
            }
            if (this.supplierQualificationList.filter((m) => m.QualificationTypeId == item1.QualificationTypeId).length == 0) {
              this.supplierQualificationList.push(data)
            }
          })
        })
      }
      // var isVaildate = false
      // this.ruleForm.SupplierType.forEach((item) => {
      //   if (item.indexOf('GC') >= 0 || item.indexOf('SP') >= 0) {
      //     isVaildate = true
      //   }
      // })
      // if ((isVaildate = true)) {
      //   this.rules.FixedAssets[0].required = true
      //   this.rules.WorkerNumber[0].required = true
      //   this.rules.QualityManagerNumber[0].required = true
      //   this.rules.TechnicianNumber[0].required = true
      //   this.rules.ProductTestingMethod[0].required = true
      //   this.rules.SupplierProductList[0].required = true
      // } else {
      //   this.rules.FixedAssets[0].required = false
      //   this.rules.WorkerNumber[0].required = false
      //   this.rules.QualityManagerNumber[0].required = false
      //   this.rules.TechnicianNumber[0].required = false
      //   this.rules.ProductTestingMethod[0].required = false
      //   this.rules.SupplierProductList[0].required = false
      // }
    },
    longterm(val) {
      if (val) {
        if (!this.ruleForm.BusinessTermDate) {
          this.ruleForm.BusinessTermDate = ['', '']
        }
      } else {
        this.ruleForm.BusinessTermDate = []
      }
    },
    CompanyTypeFn(val) {
      if (val) {
        this.$refs['CompanyType'].clearValidate()
      }
    },
    cancel() {
      let that = this

      this.getRequest('/SupplierLogin/CancelFlow?pageType=' + this.pageType)
        .then((res) => {
          var data = res.data
          if (data.errcode == 0) {
            this.auditStatus = 0
          }
        })
        .catch(function (error) {
          console.log(error)
        })
    },
    focusError() {
      setTimeout(() => {
        if (document.getElementsByClassName('el-form-item__error').length > 0) {
          // console.log(
          //   document.getElementsByClassName("el-form-item__error")[0]
          // );
          this.$message.error(document.getElementsByClassName('el-form-item__error')[0].innerText)
        }
      }, 500)
    },
    formRule() {
      if (this.type == 1) {
        return new Promise((resolve, reject) => {
          this.$refs.ruleForm1.validate((valid) => {
            if (valid) {
              this.$refs.ruleForm2.validate((valid1) => {
                if (valid1) {
                  resolve(true)
                } else {
                  this.focusError()
                  resolve(false)
                }
              })
            } else {
              this.focusError()
              resolve(false)
            }
          })
        })
      } else {
        return new Promise((resolve, reject) => {
          this.$refs.ruleForm1.validate((valid) => {
            if (valid) {
              this.$refs.ruleForm2.validate((valid1) => {
                if (valid1) {
                  resolve(true)
                } else {
                  this.focusError()
                  resolve(false)
                }
              })
            } else {
              this.focusError()
              resolve(false)
            }
          })
        })
      }
    },

    formRule() {
      return new Promise((resolve, reject) => {
        var flag = this.validateSupplierType()
        // console.log(flag);
        if (flag) {
          this.$refs.ruleForm1.validate((valid) => {
            if (valid) {
              this.$refs.ruleForm2.validate((valid1) => {
                if (valid1) {
                  this.$refs.ruleForm3.validate((valid2) => {
                    if (valid2) {
                      this.$refs.ruleForm4.validate((valid3) => {
                        if (valid3) {
                          if (this.$refs.hasOwnProperty('ruleForm6')) {
                            this.$refs.ruleForm6.validate((valid4) => {
                              resolve(true)
                              if (valid4) {
                                resolve(true)
                              } else {
                                this.focusError()
                                resolve(false)
                              }
                            })
                          } else {
                            resolve(true)
                          }
                        } else {
                          this.focusError()
                          resolve(false)
                        }
                      })
                    } else {
                      this.focusError()
                      resolve(false)
                    }
                  })
                } else {
                  this.focusError()
                  resolve(false)
                }
              })
            } else {
              this.focusError()
              resolve(false)
            }
          })
        } else {
          resolve(false)
        }

        //
      })
    },
    validateSupplierType() {
      const EmailReg = /\w[-\w.+]*@([A-Za-z0-9][-A-Za-z0-9]+\.)+[A-Za-z]{2,14}/ //邮箱验证
      const mobileReg = /^[1][3,4,5,6,7,8,9][0-9]{9}$/ //手机号验证
      var issumit = true
      if (this.ruleForm.BusinessTermDate[0] == '' && issumit == true) {
        this.$message.error('请选择营业期限')
        issumit = false
        return false
      }
      if (this.ruleForm.SupplierType.length == 0 && issumit == true) {
        this.$message.error('请选择供应商类型')
        issumit = false
        return false
      }
      if (this.ruleForm.Referrer == 0 && this.ruleForm.IntroductionSource == '0' && issumit == true) {
        this.$message.error('请填写推荐人')
        issumit = false
        return false
      }
      if (this.ruleForm.SchemeId == 0 && this.ruleForm.IntroductionSource == '1' && issumit == true) {
        this.$message.error('请填写引入项目')
        issumit = false
        return false
      }
      if (this.spplierContactList.length < 2 && issumit == true) {
        this.$message.error('联系人信息请至少填写两个')
        issumit = false
        return false
      }
      if (this.spplierContactList.filter((item) => item.IsPrimary).length == 0 && issumit == true) {
        this.$message.error('请设置一个联系人为主要联系人')
        issumit = false
        return false
      }
      this.spplierContactList.forEach((item, index) => {
        if ((item.ContactName == '' || item.ContactName == null) && issumit == true) {
          this.$message.error('请填写' + Number(index) + 1 + '行联系人的联系人名称')
          issumit = false
          return false
        }
        if ((item.Duty == '' || item.Duty == null) && issumit == true) {
          this.$message.error('请填写' + Number(index) + 1 + '行联系人的职位')
          issumit = false
          return false
        }
        if ((item.Mobile == '' || item.Mobile == null) && issumit == true) {
          this.$message.error('请填写' + Number(index) + 1 + '行联系人的手机号码')
          issumit = false
          return false
        }
        if (!mobileReg.test(item.Mobile) && issumit == true) {
          this.$message.error('请正确填写' + Number(index) + 1 + '行联系人的手机号码')
          issumit = false
          return false
        }
        if (
          this.spplierContactList.filter((item1) => {
            return item1.Mobile == item.Mobile
          }).length > 1 &&
          issumit == true
        ) {
          this.$message.error('填写的联系人的手机号码重复了，请确认')
          issumit = false
          return false
        }
        if ((item.Email == '' || item.Email == null) && issumit == true) {
          this.$message.error('请填写' + Number(index) + 1 + '行联系人的电子邮箱')
          issumit = false
          return false
        }
        if (!EmailReg.test(item.Email) && issumit == true) {
          this.$message.error('请正确填写' + Number(index) + 1 + '行联系人的电子邮箱')
          issumit = false
          return false
        }
        if (
          this.spplierContactList.filter((item1) => {
            return item1.Email == item.Email
          }).length > 1 &&
          issumit == true
        ) {
          this.$message.error('填写的联系人的电子邮箱重复了，请确认')
          issumit = false
          return false
        }
      })
      if (this.selectMainBusiness == true && issumit == true) {
        if (this.supplierMainBusinesseList.length == 0 && issumit == true) {
          this.$message.error('请录入主营业务情况（近三年），如无法提供请勾选不愿意按钮')
          issumit = false
          return false
        }
        if (this.supplierCustomDistributionList.length == 0 && issumit == true) {
          this.$message.error('请录入客户分布情况（近三年），如无法提供请勾选不愿意按钮')
          issumit = false
          return false
        }
        this.supplierMainBusinesseList.forEach((item, index) => {
          if ((item.Years == '' || item.Years == null) && issumit == true) {
            this.$message.error('请填写' + Number(index) + 1 + '行主营业务的年份')
            issumit = false
            return false
          }
          if ((item.MainBusiness == '' || item.MainBusiness == null) && issumit == true) {
            this.$message.error('请填写' + Number(index) + 1 + '行主营业务的主营业务')
            issumit = false
            return false
          }
          if ((item.ProductName == '' || item.ProductName == null) && issumit == true) {
            this.$message.error('请填写' + Number(index) + 1 + '行主营业务的具体产品/服务')
            issumit = false
            return false
          }
          if ((item.Brand == '' || item.Brand == null) && issumit == true) {
            this.$message.error('请填写' + Number(index) + 1 + '行主营业务的品牌')
            issumit = false
            return false
          }
          if ((item.MainCustome == '' || item.MainCustome == null) && issumit == true) {
            this.$message.error('请填写' + Number(index) + 1 + '行主营业务的主要客户')
            issumit = false
            return false
          }
          if ((item.Years == '' || item.Years == null) && issumit == true) {
            this.$message.error('请填写' + Number(index) + 1 + '行主营业务的年份')
            issumit = false
            return false
          }
          if ((item.BrandCompetitor == '' || item.BrandCompetitor == null) && issumit == true) {
            this.$message.error('请填写' + Number(index) + 1 + '行主营业务的品牌竞争对手')
            issumit = false
            return false
          }
          if ((item.CompanyCompetitor == '' || item.CompanyCompetitor == null) && issumit == true) {
            this.$message.error('请填写' + Number(index) + 1 + '行主营业务的主要竞争对手')
            issumit = false
            return false
          }
          if ((item.YearTotalSales == '' || item.YearTotalSales == null) && issumit == true) {
            this.$message.error('请填写' + Number(index) + 1 + '行主营业务的年营销额（万元）')
            issumit = false
            return false
          }
        })

        this.supplierCustomDistributionList.forEach((item, index) => {
          if ((item.Years == '' || item.Years == null) && issumit == true) {
            this.$message.error('请填写' + Number(index) + 1 + '行客户分布情况的年份')
            issumit = false
            return false
          }
          if ((item.IndustrialCustomers == '' || item.IndustrialCustomers == null) && issumit == true) {
            this.$message.error('请填写' + Number(index) + 1 + '行客户分布情况的客户所处行业')
            issumit = false
            return false
          }
          if ((item.Representative == '' || item.Representative == null) && issumit == true) {
            this.$message.error('请填写' + Number(index) + 1 + '行客户分布情况的客户代表')
            issumit = false
            return false
          }
          if ((item.TotalSales == '' || item.TotalSales == null) && issumit == true) {
            this.$message.error('请填写' + Number(index) + 1 + '行客户分布情况的销售额（万元）')
            issumit = false
            return false
          }
        })
      }
      if (this.selectFinance == true && issumit == true) {
        if (this.supplierFinanceStatuseList.length == 0 && issumit == true) {
          this.$message.error('请录入财务信息，如无法提供请勾选无法提供按钮')
          issumit = false
          return false
        }
        this.supplierFinanceStatuseList.forEach((item, index) => {
          if ((item.Years == '' || item.Years == null) && issumit == true) {
            this.$message.error('请填写' + Number(index) + 1 + '行财务信息的年份')
            issumit = false
            return false
          }
          if ((item.NetProfit == '' || item.NetProfit == null) && issumit == true) {
            this.$message.error('请填写' + Number(index) + 1 + '行财务信息的净利润（万元）')
            issumit = false
            return false
          }
          if ((item.TotalAssets == '' || item.TotalAssets == null) && issumit == true) {
            this.$message.error('请填写' + Number(index) + 1 + '行财务信息的资产总额（万元）')
            issumit = false
            return false
          }
          if ((item.AssetLoadRate == '' || item.AssetLoadRate == null) && issumit == true) {
            this.$message.error('请填写' + Number(index) + 1 + '行财务信息的资产负载率')
            issumit = false
            return false
          }
          if ((item.OperatingIncome == '' || item.OperatingIncome == null) && issumit == true) {
            this.$message.error('请填写' + Number(index) + 1 + '行财务信息的营业收入（万元）')
            issumit = false
            return false
          }
          if ((item.OperatingNetCash == '' || item.OperatingNetCash == null) && issumit == true) {
            this.$message.error('请填写' + Number(index) + 1 + '行财务信息的经营性净现金流（万元）')
            issumit = false
            return false
          }
        })
      }

      // let arr = this.$refs.treerefs.getCheckedKeys();
      // let arr1 = this.$refs.treerefs.getCheckedNodes();
      // if (arr.length == 0) {
      //   this.$message.error("请选择供应商类型");
      //   return false;
      // }
      // arr1.forEach(item => {
      //   if (item.other && issumit) {
      //     if (!document.getElementById(item.id).value) {
      //       this.$message.error("请输入其他供应商类型");
      //       issumit = false;
      //     } else {
      //       item.othervalue = document.getElementById(item.id).value;
      //     }
      //   }
      // });
      // this.ruleForm.SupplierType = JSON.stringify(arr1);
      return issumit
    },
    deduplicateObjects() {
      const seen = new Set()
      // 必须将结果重新赋值给 this.userList，才能触发视图更新
      this.spplierContactList = this.spplierContactList.filter((item) => {
        // 如果 seen 中已存在该 id，则过滤掉；否则加入 seen 并保留
        return !seen.has(item.ContactName) && seen.add(item.ContactName)
      })
    },
    async submit(submit) {
      this.deduplicateObjects()
      // console.log(this.ruleForm.SupplierProductList.length == 0 && this.ruleForm.OtherSupplierProductList === '')
      if (submit) {
        let isSubmit = await this.formRule()
        this.$refs.MsgForm1.ruleList()
        this.$refs.MsgForm3.ruleList()
        this.$refs.MsgForm4.ruleList()
        if (this.ruleForm.TaxPayerSize != 3 && this.ruleForm.TaxPayerSize != 4) {
          this.$refs.QualificationForm.ruleList()
        }

        console.log('sss', isSubmit)
        if (
          this.$refs.MsgForm1.iserror &&
          this.$refs.MsgForm3.iserror &&
          this.$refs.MsgForm4.iserror &&
          this.$refs.QualificationForm.iserror &&
          isSubmit
        ) {
          this.save(submit)
        }
      } else {
        this.$refs.MsgForm1.ruleList1()
        this.$refs.MsgForm3.ruleList1()
        this.$refs.MsgForm4.ruleList1()
        if (this.ruleForm.TaxPayerSize != 3 && this.ruleForm.TaxPayerSize != 4) {
          this.$refs.QualificationForm.ruleList1()
        }

        this.save(submit)
      }
    },
    reflash() {
      this.reload()
    },
    save(isSubmit) {
      var fileList = []
      var fileList1 = []
      if (this.ruleForm.TaxPayerSize != 3 && this.ruleForm.TaxPayerSize != 4) {
        fileList1 = this.$refs.QualificationForm.list
      }
      fileList.push(...this.$refs.MsgForm1.list)
      // console.log(fileList)
      // fileList.push(...this.$refs.MsgForm3.list)
      // console.log(fileList)
      // fileList.push(...this.$refs.MsgForm4.list)
      // console.log(fileList)
      if (this.showFinance == false || this.selectFinance == false) {
        this.supplierFinanceStatuseList = []
      }
      if (this.showMainBusiness == false || this.selectMainBusiness == false) {
        this.supplierMainBusinesseList = []
        this.supplierCustomDistributionList = []
      }
      this.ruleForm.PageType = this.pageType
      this.postRequest('SupplierLogin/SupplierChangeApply', {
        fileListJson: JSON.stringify(fileList),
        qualificationListJson: JSON.stringify(fileList1),
        baseDataJson: JSON.stringify(this.ruleForm),
        contactListJson: JSON.stringify(this.spplierContactList),
        mainBusinesseListJson: JSON.stringify(this.supplierMainBusinesseList),
        financeStatuseListJson: JSON.stringify(this.supplierFinanceStatuseList),
        customDistributionListJson: JSON.stringify(this.supplierCustomDistributionList),
        isSubmit: isSubmit
      })
        .then((res) => {
          if (res.data.errcode == 0) {
            if (isSubmit) {
              this.$message.success('提交成功！')
              this.back()
              this.auditStatus = 1
            } else {
              this.$message.success('保存成功！')
              this.supplierId = res.data.supplierId
            }
          } else {
            this.$message.error(res.data.errmsg)
          }
        })
        .catch(function (error) {
          console.log(error)
        })
    },

    // renderContent(h, { node, data, store }) {
    //   if (data.other) {
    //     return (
    //       <span class="custom-tree-node">
    //         <span>{node.label}</span>
    //         <input
    //           id={data.id}
    //           value={data.othervalue}
    //           style="height:26px;line-height:26px;margin-left:5px"
    //           class="el-input__inner otherinput"
    //         />
    //       </span>
    //     );
    //   } else {
    //     return (
    //       <span class="custom-tree-node">
    //         <span>{node.label}</span>
    //       </span>
    //     );
    //   }
    // },
    openSupplierTypePage() {
      this.dialogvisible = true
    },
    setIsPrimary(index1) {
      if (this.spplierContactList[index1].IsPrimary == true) {
        for (let index = 0; index < this.spplierContactList.length; index++) {
          if (index != index1) {
            this.spplierContactList[index].IsPrimary = false
          }
        }
      }
    },
    querySearchAsync() {
      this.userList = []
      this.postRequest('Common/GetUserByMobile', {
        mobile: this.ReferrerName
      }).then((res) => {
        if (res.data.errcode == 0) {
          this.userList = res.data.userList
          const reg = /^1[3-9]{1}[0-9]{9}$/
          var results = this.ReferrerName
            ? this.userList.filter((item) => {
                return item.Mobile1 == this.ReferrerName
              })
            : []
          if (!reg.test(this.ReferrerName)) {
            this.$message.error('请输入正确的推荐人手机号！')
            this.ruleForm.Referrer = 0
          }
          if (reg.test(this.ReferrerName) && results.length == 0) {
            this.$message.error('供应商入库推荐人的手机号码默认为我司员工在我司系统报备号码，现查无此人，请联系我司对接人员！')
            this.ruleForm.Referrer = 0
          }
          if (results.length > 0) {
            this.ruleForm.Referrer = results[0].UserId
            this.ruleForm.ReferrerName = results[0].UserName
            this.ruleForm.ReferrerMobile = results[0].Mobile1
          }
        } else {
          this.$message.error(res.data.errmsg)
        }
      })
    },
    handleSelect(item) {
      this.ruleForm.Referrer = item.UserId
      this.ruleForm.ReferrerName = item.UserName
      this.ruleForm.ReferrerMobile = item.Mobile1
    },
    deleteReferrerName() {
      this.ruleForm.Referrer = 0
      this.ruleForm.ReferrerName = ''
      this.ruleForm.ReferrerMobile = ''
    },
    querySearchAsync1() {
      this.schemeList = []
      this.postRequest('Common/GetSchemeByProjectName', {
        projectName: this.ProjectName
      }).then((res) => {
        if (res.data.errcode == 0) {
          this.schemeList = res.data.schemeList
          if (this.schemeList.length == 0) {
            this.$message.error('未找到项目，请确认！')
            this.ruleForm.SchemeId = 0
          }
          if (this.schemeList.length > 0) {
            this.ruleForm.SchemeId = this.schemeList[0].SchemeId
            this.ruleForm.ProjectName = this.schemeList[0].ProjectName
          }
        } else {
          this.$message.error(res.data.errmsg)
        }
      })
    },
    deleteProjectName() {
      this.ruleForm.SchemeId = 0
      this.ruleForm.ProjectName = ''
    },
    IntroductionSourceFn(val) {
      if (this.ruleForm.IntroductionSource == 1) {
        if (this.ruleForm.SocialCreditCode == '' || this.ruleForm.SocialCreditCode == null) {
          this.ruleForm.IntroductionSource = '0'
          this.$message.error('请先输入社会信用代码后选择引入来源')
        }
        this.postRequest('SupplierLogin/ValidateIntroductionSource', {
          socialCreditCode: this.ruleForm.SocialCreditCode
        }).then((res) => {
          if (res.data.errcode == 0) {
            this.rules.ReferrerName[0].required = false
          } else {
            this.$message.error(res.data.errmsg)
            this.ruleForm.IntroductionSource = '0'
          }
        })
      } else {
        this.rules.ReferrerName[0].required = true
      }
    },
    selectMainBusinessChange() {},
    selectFinanceStatusChange() {}
  }
}
</script>

<style lang="scss" scoped>
.content_wrap {
  padding-bottom: 20px;
  margin-bottom: 20px;
}

.changeInform_btn_wrap {
  width: 366px;
  margin: 40px auto 0;

  .btn_1 {
    background: #055ba9;
    color: #fff;
    border: none;
  }
}

.supplierType {
  .el-form-item {
    display: inline-block;
    flex: 0 0 200px;

    .el-input {
      width: 200px;
    }
  }

  .supplierOtherType {
    ::v-deep.el-form-item__content {
      border-bottom: none;
    }
  }
}

::v-deep.businessTermDate {
  .el-form-item__content {
    align-items: center;
  }

  .term {
    margin-top: 0 !important;
    margin-left: 0 !important;
  }

  .el-input {
    width: 300px;
    margin-right: 8px;
  }

  .businessTermEndDate {
    margin-bottom: 0 !important;

    .el-input {
      width: 100% !important;
    }

    .el-form-item__label:before {
      display: none;
    }

    .el-form-item__content {
      border-bottom: none;
    }
  }
}

::v-deep.el-form-item {
  .el-input.is-disabled .el-input__inner,
  .el-select .el-input.is-disabled .el-input__inner,
  .el-checkbox__input.is-disabled + span.el-checkbox__label,
  .el-textarea.is-disabled .el-textarea__inner {
    color: #606266;
  }
}

.back_btn {
  height: 26px;
  bottom: 7px;
  padding: 0 18px;
  border-radius: 14px;
}

.businessTermDate1 ::v-deep.el-input__inner {
  min-width: 150px !important;
}

.tableWrap5_custom ::v-deep.btn_wrap {
  margin-right: 12px;
  margin-top: 15px;
}

.tableWrap5_custom ::v-deep.tab_wrap5 {
  margin: 0 15px 15px;

  .product_form {
    margin-bottom: 0;
  }

  .table_1 {
    width: 100%;
    margin: 0;
  }

  .table_1 tr td {
    border-right: none;
    border-bottom: none;
  }
}

.change_inform ::v-deep.icon_tips2 {
  vertical-align: middle !important;
}

.rangeDate ::v-deep.el-form-item__content {
  .el-input__inner,
  .el-range-editor {
    width: 300px;
    margin-right: 8px;
    text-align: center;

    .el-range-input {
      font-size: 14px;
    }
  }
}

.tree ::v-deep .el-tree-node {
  .el-tree-node__children {
    white-space: normal;

    .el-tree-node {
      display: inline-block;
    }
  }
}

.otherinput {
  height: 25px;
  line-height: 40px;
  width: 100%;
}

.width_full {
  width: 100% !important;
}
.cascader {
  ::v-deep .el-input-group__prepend {
    padding: unset;
    border: unset;
    border-radius: unset;
  }
}

.name_wrap {
  border: 1px solid #606266;
  margin-left: 11px;
  border-radius: 10px;
  padding: 0 4px;
}

.name_wrap2 {
  display: inline-block;
  padding: 5px;
}
.radio-group-container {
  max-width: 600px;
  padding-top: 20px;
  padding-left: 30px;
  border-radius: 8px;
}

.question {
  font-size: 16px;
  color: #303133;
  margin-bottom: 24px;
  line-height: 1.5;
  font-weight: bold; /* 加粗 */
}

.custom-radio {
  display: block;
  margin-bottom: 16px;
  padding: 8px 0;
}

.custom-radio .radio-label {
  font-size: 15px;
  color: #303133;
  vertical-align: middle;
  font-weight: bold; /* 加粗 */
}

.hint-text {
  font-size: 13px;
  color: #909399;
  margin-left: 8px;
  vertical-align: middle;
  font-weight: normal; /* 提示文字保持正常粗细 */
}

/* 高亮已选中的 radio 圆点 */
.el-radio.is-checked .el-radio__input.is-checked .el-radio__inner {
  border-color: #409eff;
  background-color: #409eff;
}

.el-radio__input.is-checked + .el-radio__label {
  color: #303133;
  font-weight: bold; /* 已选中项标签也加粗 */
}
.input_number1 ::v-deep.el-input--mini {
  width: 100% !important;
}
</style>